AuthRoute = require 'mixins/authenticated-route'

App.BonusCategoriesBonusCategoryRoute = Em.Route.extend AuthRoute,
  afterModel: (model) ->
    @transitionTo 'bonus-categories.bonus-category.edit', model

  model: (params) ->
    @store.fetchById('client-tag', params.client_tag_id)